// import styled from "styled-components";
import styled from "styled-components";
import { colors } from "../../../libs/themes";

interface EventCardBodyWrapperProps {
  width?: string;
}

export const EventCard = styled.div`
    height: 100%;
    margin: 0 auto;
    position: relative;
    transition: all 0.3s ease-out;

    @media(hover: hover) {
        &:not(.is-today):hover,
        &:not(.is-upcoming):hover {
            cursor: pointer !important;
            pointer-events: all !important;
            transition: all 0.3s ease-out;
        }

        &:hover .event-button {
            background-color: rgba(255,255,255, 1) !important;
            transition: all 0.3s ease-out;
        }
    }

    &.is-upcoming {
        cursor: default;
        pointer-events: none;

        &.is-private {
            cursor: pointer;
            pointer-events: all;
            transition: all 0.3s ease-out;
        }
    }

     .event-button {
        transition: all 0.3s ease-out;
    }
`;

export const EventCardBodyWrapper = styled.div<EventCardBodyWrapperProps>`
    height: 128px;
   // padding: 20px;
    padding: 0px 15px;
   // width: 100%;
    width: ${(props) => props.width || "100%"};
    align-items: center;
    background: rgba(255, 255, 255, 1);
`;

export const Title = styled.div`
    font-size: 18px !important;
    font-weight: 700 !important;
    color: rgba(11,11,11, 1) !important;
    -webkit-line-clamp: 2 !important;
    -webkit-box-orient: vertical !important;
    margin-bottom: 8px !important;
    overflow: hidden !important;
    display: -webkit-box !important;
`;

export const TitleWrapper = styled.div`
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    gap: 8px;
`;

export const Type = styled.span`
    margin-top: 20px;
    background: rgba(204,204,204, 1);
    padding: 5.008px 20px;
    display: inline-block;

    &.private,
    &.live {
        background: #DC3545;
        color: rgba(255,255,255, 1);
    }
`;

export const Logo = styled.img`
    width: 75px;
    height: 75px;
    object-fit: contain;
    object-position: 50% 50%;
    position: relative;
`;

export const EventCardDetailWrapper = styled.div`
    //height: 70px;
    background: rgba(11,11,11, 1);
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 20px;
    
    &.is-now {
        background: linear-gradient(to right bottom, rgba(184,249,79, 1), rgba(11,11,11, 1));
    }
    
    &.is-today {
        background: linear-gradient(to right bottom, #ff9900, rgba(11,11,11, 1));
    }
    
    &.is-upcoming {
        background: linear-gradient(to right bottom, #6bb7f3, rgba(11,11,11, 1));
    }
    
    &.is-past {
        background: linear-gradient(to right bottom, #ff0000, rgba(11,11,11, 1));
    }
`;

export const EventDateWrapper = styled.div`
    font-size: 14px;
    font-weight: 700;
    line-height: 1;
    color: rgba(255,255,255, 1);
    margin: 0;
`;

export const EventActionWrapper = styled.div`
    font-size: 14px;
    font-weight: 700;
    line-height: 1;
    color: rgba(255,255,255, 1);
    margin: 0;
    display: flex;
    align-items: end;
    gap: 8px;
`;

export const Divider = styled.div<{eventType?: string}>`
    height: 10px;
    background: rgba(204,204,204, 1);
    
    &.is-now {
        background: linear-gradient(to right bottom, rgba(184,249,79, 1), rgba(11,11,11, 1));
    }
    
    &.is-today {
        background: linear-gradient(to right bottom, #ff9900, rgba(11,11,11, 1));
    }
    
    &.is-upcoming {
        background: linear-gradient(to right bottom, #6bb7f3, rgba(11,11,11, 1));
    }
    
    &.is-past {
        background: linear-gradient(to right bottom, #ff0000, rgba(11,11,11, 1));
    }
`;






















interface MediaCardWrapperProps {
    customBorderRadius?: string;
    isSelected?: boolean
}

export const MediaPoster = styled.div<{ applyResponsive?: boolean }>`
    position: relative;
    width: 256px;
       ${({ applyResponsive }) => applyResponsive && `
        @media (max-width: 900px) {
            width: 160px;
        }
        @media (max-width: 767px) {
            width: 256px;
        }
    `}
    &.hover-intent:not(.is-mobile) {

        & .media-poster--link {

            & .watch-label {
                visibility: visible;
                opacity: 1;
                transform: translateX(-50%) scale(1);
                transition: opacity 0.3s ease-out 0.15s, transform 0.3s var(--ease-out-back) 0.15s;
            }
        }

        & .media-poster--art {
            border-bottom-left-radius: 0;
            border-bottom-right-radius: 0;
            transition: all 0.3s ease-out;
            
            & img {
                border-bottom-left-radius: 0;
                border-bottom-right-radius: 0;
                box-shadow: 0px -5px 15px -3px var(--video-card-poster-shadow-color);
                transition: all 0.3s ease-out;
            }
        }
    }
`;

export const MediaPosterLink = styled.a`
    line-height: 0;
    text-decoration: none;
    width: 100%;
    height: 100%;
    padding: 12px 24px;
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 999;

    @media(hover: hover) {
        &:hover {
            cursor: pointer;
            transition: transform 0.3s ease;
        }
    }

    &:focus {
        outline: none;
    }

`;

export const EventBadge = styled.div`
    position: absolute;
    top: 8px;
    left: 8px;
    background-color: #E50914; /* or dynamic via class */
    color: white;
    padding: 4px 8px;
    font-size: 12px;
    font-weight: bold;
    border-radius: 6px;
    z-index: 10;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 26px;

    &.is-now {
        background-color: #FF0000;
    }

    &.is-today {
        background-color: #FFA500;
    }

    &.is-upcoming {
        background-color: #007BFF;
    }

    &.is-past {
        background-color: #6c757d;
    }

    &.is-private {
        border: 2px solid white;
    }

    img {
        display: block;
        height: 100%;
    }
`;

export const NotchBadge = styled.div`
  position: absolute;
  top: 0px;
  left: 50%;
  transform: translateX(-50%);
  background-color: transparent;
  width: 200px;
  height: 26px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
`;

export const MediaPosterArt = styled.div`
    line-height: 0;
    aspect-ratio: 16 / 9;
    background-color: rgba(0,0,0, 0.06);
    box-shadow: inset 0 0 6px rgba(0,0,0,0.12);
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
    border-top-left-radius: var(--video-card-border-radius);
    border-top-right-radius: var(--video-card-border-radius);
    
    @media (min-width: 576px) {
        
    }
    @media (min-width: 768px) {
        &:not(.is-mobile) {
            border-bottom-left-radius: var(--video-card-border-radius);
            border-bottom-right-radius: var(--video-card-border-radius);
        }
    }
    @media (min-width: 992px) {
        
    }
    @media (min-width: 1200px) {
        
    }
    @media (min-width: 1400px) {
        
    }
`;

export const MediaPosterImage = styled.img`
    width: 100%;
    height: auto;
    aspect-ratio: 16 / 9;
    object-fit: cover;
    object-position: 50% 50%;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
    border-top-left-radius: var(--video-card-border-radius);
    border-top-right-radius: var(--video-card-border-radius);
    transition: all 0.3s ease-out;

    @media (min-width: 576px) {
        
    }
    @media (min-width: 768px) {
        &:not(.is-mobile) {
            border-bottom-left-radius: var(--video-card-border-radius);
            border-bottom-right-radius: var(--video-card-border-radius);
        }
    }
`;

export const MediaAncillary = styled.article`
    background-color: var(--video-card-bg-color);
    width: 100%;
    max-height: none;
    padding: 0 20px 18px 20px;
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
    box-shadow: 0px 10px 15px -3px var(--video-card-shadow-color);
    margin-top: -1px;
    opacity: 1;
    overflow: hidden;
    display: flex;
    flex-flow: column nowrap;
    flex: 1 1 auto;
    position: relative;
    top: auto;
    transition: all 0.3s ease-out;
    will-change: max-height, opacity;
    display:none;

    @media (min-width: 576px) {

    }
    @media (min-width: 768px) {
        &:not(.is-mobile) {
            max-height: 0;
            opacity: 0;
            flex: 0 1 auto;
            position: absolute;
            top: 100%;
        }
    }
    @media (min-width: 992px) {

    }
    @media (min-width: 1200px) {

    }
    @media (min-width: 1400px) {

    }

    &.hover-intent:not(.is-mobile) {
        max-height: 420px;
        padding: 0 20px 20px 20px;
        opacity: 1;
        transition: all 0.3s ease-out;
    }

    & section {
        margin-top: 12px;
    }
`;

export const MediaMetadata = styled.section`

`;

export const MediaHighlight = styled.span`
    font-size: 13.008px;
    font-weight: 700;
    line-height: 1.337;
    text-transform: initial;
    color: var(--video-card-text-color-alt);
    margin-top: 8px;
    display: none;
`;

export const MediaSynopsis = styled.div`
    font-size: 13.008px;
    font-weight: 400;
    line-height: 1.337;
    text-transform: initial;
    color: var(--video-card-text-color-alt);
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    max-height: calc(var(21.392px) * 3);
    margin-top: 8px;
    overflow: hidden;
    display: -webkit-box;
`;

export const MediaGenre = styled.div`
    font-size: 13.008px;
    font-weight: 400;
    line-height: 1.337;
    text-transform: initial;
    color: var(--video-card-text-color-alt);
    margin-top: 8px;

    & > span {
        margin-right: 12px;
        position: relative;

        &::after {
            content: '◦';
            font-size: 14px;
            font-weight: 400;
            line-height: 1.337;
            color: var(--video-card-separator-color);
            width: 12px;
            height: 12px;
            position: absolute;
            top: 50%;
            right: -15.008px;
            transform: translateY(calc(-50% + 1.008px));
        }

        &:last-of-type {
            margin-right: 0;

            &::after {
                display: none;
            }
        }
    }
`;

export const MediaCrew = styled.div`
    margin-top: 8px;

    & h5 {
        font-size: 13.008px;
        font-weight: 400;
        line-height: 1.337;
        text-transform: initial;
        color: var(--video-card-text-color-alt);
        margin-top: 0;
        margin-bottom: 8px;

        &:last-of-type {
            margin-bottom: 0;
        }

        & > span {
            font-weight: 700;
            display: block;
        }
    }
`;

export const MediaRating = styled.div`
    margin: 8px 0 4px 0;
    display: flex;
    flex-flow: row;
    justify-content: flex-start;
    align-items: center;
`;

export const MediaCard = styled.article`
    position: relative;
    z-index: 5;
    border-radius:10px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
    &.hover-intent:not(.is-mobile) {
        z-index: 15;
        box-shadow: 0 8px 16px rgba(0, 0, 0, 0.3); 
        & .media-card--wrapper {
            transform: scale(1.063);
            transition: all 0.3s ease-out;
        }
    }
`;


export const MediaCardWrapper = styled.div<MediaCardWrapperProps>`
    position: relative;
    width: 100%;
    border: ${({ isSelected }) => (isSelected ? "2px solid #000000" : "2px solid transparent")};
    border-radius: 8px;
    overflow: hidden;
    transition: box-shadow 0.3s ease;

    &::after {
        content: "";
        position: absolute;
        top: 0; left: 0;
        width: 100%;
        height: 100%;
        background: ${colors.background.transparentBlack};
        opacity: 0;
        transition: opacity 0.3s ease;
        pointer-events: none;
        z-index: 9;
    }

    &:hover {
        box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
        transition: box-shadow 0.3s ease, transform 0.3s ease;

        &::after {
            opacity: 1;
        }
    }
`;
